import { CircularProgress, Typography } from '@mui/material'
import { FC } from 'react'
import { useCountdown } from '../../hooks/useCountdown'

export const Countdown: FC<{ resetDate: string; callback?: () => void; loader?: boolean }> = ({
    resetDate,
    callback,
    loader = true,
}) => {
    const timeLeftForReset = useCountdown(resetDate, callback)

    return (
        <>
            {timeLeftForReset ? (
                <Typography
                    sx={{ fontVariantNumeric: 'tabular-nums' }}
                    textTransform="capitalize"
                    fontWeight={'bold'}
                    variant="body2"
                >
                    {timeLeftForReset}
                </Typography>
            ) : (
                resetDate && loader && <CircularProgress sx={{ m: '0 auto' }} size={24} color="primary" />
            )}
        </>
    )
}
